import React from 'react';

type ImageModalProps = {
  onClick: () => void,
  imageSrc: string,
  isVisible?: boolean,
}

export const FULLSIZE_IMAGE_MODAL_DIV_ID = 'full-size-image-help-modal';

export const FullSizeImageModal = ({
  onClick,
  imageSrc,
  isVisible = false,
}: ImageModalProps) => {
  if (isVisible) {
    return (
      <div
        className="FullSizeImageModal__overlay"
        onClick={onClick}
      >
        <div className="content">
          <img alt="" src={imageSrc} />
        </div>
      </div>
    );
  }

  return null;
};
